import { DataGrid, type DataGridProps } from '@shared/components';

import { columns } from './columns';

export type ExamCenterExamCourseDataGridProps = Omit<
  DataGridProps,
  'sx' | 'columns' | 'disableColumnMenu'
>;

export default function ExamCenterExamCourseDataGrid(
  props: Readonly<ExamCenterExamCourseDataGridProps>,
) {
  return (
    <DataGrid
      {...props}
      columns={columns}
      disableColumnMenu
      getRowHeight={() => 48}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '.MuiDataGrid-columnHeader': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-cell[data-field="moreAction"]': {
          padding: theme.spacing(1.5),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
